<template>
    <form
        method="POST"
        enctype="multipart/form-data"
        :action="route"
        class="mx-5"
    >
        <div
            v-if="projs[0].customer.checklist.requirement.optional == 1"
            class="form-check"
        >
            <input type="checkbox" name="checkbox" />
            <p>Optional</p>
        </div>
        <input type="hidden" name="_token" :value="token" />
        <div class="row mx-auto">
            <table class="mx-auto" style="width:100%;">
                <tbody>
                    <tr v-for="(project, index) in projs" :key="index">
                        <input
                            type="hidden"
                            :name="'form[' + index + '][id]'"
                            :value="project.customer.id"
                        />
                        <td
                            v-if="!as_pro"
                            class="text-left fts-12 font-weight-bold p-3"
                            style="vertical-align: middle; min-width:40%;"
                        >
                            {{ project.customer.checklist.requirement.name }}
                        </td>
                        <td
                            v-else
                            class="text-left fts-12 font-weight-bold p-3"
                            style="vertical-align: middle; min-width: 100%;"
                        >
                            <span class="colorabc2">{{
                                project.customer.checklist.requirement.name
                            }}</span>
                            for {{ project.customer.project.name }}
                        </td>
                        <td
                            v-if="!as_pro"
                            class="text-left fts-12"
                            style="vertical-align: middle; width:20%;"
                        >
                            <div>
                                <label
                                    for="upload-photo"
                                    class="btn-abc"
                                    style="padding: 10px;"
                                    id="choosefile"
                                >
                                    {{ __("traductionview.choisir") }}</label
                                >
                                <input
                                    type="file"
                                    id="upload-photo"
                                    class="form-input"
                                    style="color: #F18928; margin: 0 auto; max-width:80%;"
                                    :name="'logo[' + index + ']'"
                                    @change="filename"
                                    ref="files"
                                />
                            </div>
                        </td>
                        <td
                            v-if="!as_pro"
                            class="text-left fts-12 font-weight-bold"
                            style="vertical-align: middle; width:20%;"
                        >
                            for {{ project.customer.project.name }}
                        </td>
                        <td
                            v-if="!as_pro"
                            class="text-center"
                            style="vertical-align: middle; width:15%;"
                        >
                            <a
                                class="fts-12 font-weight-bold"
                                style="cursor:pointer;"
                                v-on:click="addRaw"
                                ><svg
                                    width="1.2em"
                                    height="1.2em"
                                    viewBox="0 0 16 16"
                                    class="bi bi-plus-circle mr-2 mb-1"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                                    />
                                </svg>
                                {{ __("traductionview.ajouter") }}</a
                            >
                        </td>
                        <td
                            v-if="!as_pro"
                            style="vertical-align: middle; width:5%;"
                        >
                            <button
                                style="font-size:24px!important; text-align:center; vertical-align:middle; color:red;"
                                v-if="!project.disabled"
                                type="button"
                                class="close"
                                aria-label="Close"
                                v-on:click="
                                    projs.splice(projs.indexOf(project), 1)
                                "
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="my-3 text-right">
            <p v-if="!as_pro">
                <button
                    type="submit"
                    :disabled="!valid"
                    class="btn-abc-green-submit fts-12 triggerspinner"
                    style="padding:10px;"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-circle mr-2"
                        style="margin-bottom:2px;"
                        viewBox="0 0 16 16"
                    >
                        <path
                            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                        />
                        <path
                            d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                        />
                    </svg>
                    {{ __("traductionview.envoyer") }}
                </button>
            </p>
        </div>
        <div
            style="border-bottom: 1px solid rgb(206,206,206); width: 100%;"
            class="mb-5"
        ></div>
    </form>
</template>

<script>
export default {
    props: ["checklist_users", "as_pro", "token", "route"],

    data() {
        return {
            form: [],
            customs: [],
            projs: [],
            files: "",
            valid: false
        };
    },

    mounted() {
        this.projs.push({
            id: null,
            customer: this.checklist_users
        });
    },
    methods: {
        filename(event) {
            this.valid = true;
        },
        async submitFiles() {
            const formData = new FormData();
            for (let i = 0; i < this.files.length; i++) {
                formData.append("files[" + i + "]", this.files[i]);
            }

            try {
                await axios.post("/multiple-files", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                console.log("SUCCESS!!");
            } catch (error) {
                console.log("FAILURE!!");
            }
        },
        handleFilesUpload() {
            this.files = this.$refs.files.files;
        },

        addRaw() {
            this.projs.push({
                id: null,
                customer: this.checklist_users
            });
        }
    }
};
</script>
